// extracted by mini-css-extract-plugin
var _1 = "DWjpjB1TVezKbxgnyEC3";
var _2 = "szyOQ3ZuRdU0MnupFbBw";
var _3 = "iuRvvfWYy8JlPqkH0nbP";
export { _1 as "body", _2 as "centered", _3 as "dark" }
